
import { Component, Vue, Prop } from "nuxt-property-decorator";
@Component
export default class LuogoVisione extends Vue {
  @Prop() title!: string;
  @Prop() fields!: any;
  @Prop() wrapperClass!: string;
}
